import { Roles } from "../../../../constants/roles";
import { snsPreviewManagerForm } from "../../sns-preview-manager-form";

export class CardPreviewMediaAreaRender {
    public static findCardMediaArea(cardElement: Element): HTMLElement | null {
        if (!(cardElement instanceof Element)) return null;

        const boardMediaArea = snsPreviewManagerForm.getBoardMediaArea(cardElement);
        if (boardMediaArea instanceof HTMLElement) return boardMediaArea;

        const alternatives = [
            `[data-role="${Roles.BOARD_MEDIA_AREA}"]`,
            ".content-wrapper",
            ".card-body",
            `[data-role="${Roles.POST_CONTENT_DISPLAY}"]`,
            `[data-role="${Roles.POST_DETAIL_CONTENT}"]`,
            ".board-content",
            ".placeholder-icon",
        ];
        for (const selector of alternatives) {
            const alt = snsPreviewManagerForm.getAlternativeCardMediaArea(cardElement, selector);
            if (alt instanceof HTMLElement) return alt;
        }

        return null;
    }
}
